<template>
  <RouterView />
</template>

<script>
import { READ, UPDATE } from '@/plugins/user'
export default {
  data () {
    return {
      title: 'Account',
      breadcrumb: {
        name: new Promise((resolve) => {
          this.$sdk
            .account
            .read(this.$route.params.accountId)
            .then((response) => {
              resolve(response.name)
            })
        }),
        route: { name: 'manage-accounts-account', params: { accountId: this.$route.params.accountId } }
      },
      sidebar: [
        {
          hidden: this.$user.cannot(READ, this.$sdk.account),
          icon: ['fal', 'file-user'],
          route: { name: 'manage-accounts-account-details', params: { accountId: this.$route.params.accountId } },
          name: 'Details'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], this.$sdk.account),
          icon: ['fal', 'cogs'],
          route: { name: 'manage-accounts-account-configurations', params: { accountId: this.$route.params.accountId } },
          name: 'Configure'
        },
        {
          hidden: this.$user.cannot(READ, 'account_invoicesurcharge'),
          icon: ['fal', 'money-check-alt'],
          route: { name: 'manage-accounts-account-billings', params: { accountId: this.$route.params.accountId } },
          name: 'Billing'
        },
        {
          hidden: this.$user.cannot(READ, 'account_contact'),
          icon: ['fal', 'phone'],
          route: { name: 'manage-accounts-account-contacts', params: { accountId: this.$route.params.accountId } },
          name: 'Contacts'
        },
        {
          hidden: this.$user.cannot(READ, 'account_attachment'),
          icon: ['fal', 'paperclip'],
          route: { name: 'manage-accounts-account-attachments', params: { accountId: this.$route.params.accountId } },
          name: 'Attachments'
        },
        {
          hidden: this.$user.cannot(READ, 'account_address'),
          icon: ['fal', 'address-book'],
          route: { name: 'manage-accounts-account-addresses', params: { accountId: this.$route.params.accountId } },
          name: 'Address Book'
        },
        {
          hidden: this.$user.cannot(READ, 'account_address'),
          icon: ['fal', 'fire-extinguisher'],
          route: { name: 'manage-accounts-account-itemsdg', params: { accountId: this.$route.params.accountId } },
          name: 'Dangerous Goods'
        },
        {
          hidden: this.$user.cannot(READ, 'account_address'),
          icon: ['fal', 'boxes'],
          route: { name: 'manage-accounts-account-items', params: { accountId: this.$route.params.accountId } },
          name: 'Items'
        },
        {
          hidden: this.$user.cannot(READ, 'account_location'),
          icon: ['fal', 'location-arrow'],
          route: { name: 'manage-accounts-account-locations', params: { accountId: this.$route.params.accountId } },
          name: 'Locations'
        },
        {
          hidden: this.$user.cannot(READ, 'account_address'),
          icon: ['fal', 'bullseye'],
          route: { name: 'manage-accounts-account-cost-centres', params: { accountId: this.$route.params.accountId } },
          name: 'Cost Centres'
        },
        {
          hidden: this.$user.cannot(READ, 'account_note'),
          icon: ['fal', 'sticky-note'],
          route: { name: 'manage-accounts-account-notes', params: { accountId: this.$route.params.accountId } },
          name: 'Notes'
        },
        {
          hidden: this.$user.cannot(READ, 'account_note'),
          icon: ['fal', 'credit-card-front'],
          route: { name: 'manage-accounts-account-ratecards', params: { accountId: this.$route.params.accountId } },
          name: 'Rate Cards'
        },
        {
          hidden: this.$user.cannot(READ, 'account_note'),
          icon: ['fal', 'sack-dollar'],
          route: { name: 'manage-accounts-account-surcharges', params: { accountId: this.$route.params.accountId } },
          name: 'Surcharges'
        },
        {
          hidden: this.$user.cannot(READ, 'account_note'),
          icon: ['fal', 'person-dolly'],
          route: { name: 'manage-accounts-account-pickups', params: { accountId: this.$route.params.accountId } },
          name: 'Pickups'
        }
      ]
    }
  }
}
</script>
